// Kept it to 0 to avoid any retries.
export const AI_DETECTION_MAX_RETRIES = 0;
export const AI_DETECTION_RETRY_BASE_DELAY_MS = 2000;

export const AI_DETECTION_FINAL_ERROR_MESSAGE =
  "AI Detection is temporarily unavailable. Please try again later. If the problem persists, please contact support.";

export const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));
